import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import { getFormsAccessToken } from '../../../utils/FormsStorageUtils';

import {
  ClientLoginWithCodeRequestType,
  ClientLoginWithCodeResponseType,
  RefreshAuthTokensRequestType,
  RefreshAuthTokensResponseType
} from './types';

import { FormsAuthAPIServiceTypes } from '.';

class FormsAuthAPIService implements FormsAuthAPIServiceTypes {
  api: ApisauceInstance;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['FORMS_AUTH_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  onLogin(
    requestObject: ClientLoginWithCodeRequestType
  ): Promise<ClientLoginWithCodeResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'login/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getRefreshToken = (
    requestObject: RefreshAuthTokensRequestType
  ): Promise<RefreshAuthTokensResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `refresh_auth_tokens/v1/`,
      requestObject,
      apiMethods.post,
      {
        getAccessToken: () => getFormsAccessToken()
      }
    );
  };
}

export { FormsAuthAPIService };
